import { uniq } from 'lodash';
import usePreview3DStore from 'src/components/widgets/preview3D/store';

export default function usePreview3DValidation() {
    const [zkProduct, sceneEditor] = usePreview3DStore((x) => [x.zkProduct, x.sceneEditor]);

    const validate = () => {
        const hasMultipleVariants = zkProduct!.get('colors').length > 1;
        const amountOfSides = uniq(
            zkProduct!
                .get('colors')
                .toArray()
                .flatMap((x) => x.get('sides').toArray())
                .map((s) => s.get('sideID'))
        ).length;

        const amountOfMeshesWithGeometry =
            sceneEditor?.scene?.meshes.filter((x) => x!.subMeshes && x!.subMeshes.length > 0).filter((x) => sceneEditor!.isRealMesh(x)).length ?? 0;

        const hasValidAmountOfMeshes = amountOfMeshesWithGeometry >= amountOfSides;

        return {
            hasMultipleVariants,
            amountOfSides,
            amountOfMeshesWithGeometry,
            hasValidAmountOfMeshes
        };
    };

    return validate;
}
